import agencies from './agencies';

export default function* () {
    yield* [...agencies];
}
